// globalIdentifierTypes with their scheme + authority + path
export enum GlobalIdentifierEnum {
    URL = 1,
    DOI = 2,
    DOI_PATH = 'https://doi.org/',
    ISBN = 3,
    ISSN = 4,
    EISSN = 5,
    DNBID = 6,
    DNBID_PATH = 'http://d-nb.info/',
    PMCID = 7,
    PMCID_PATH = 'https://europepmc.org/articles/',
    HANDLE = 8,
    HANDLE_PATH = 'http://hdl.handle.net/',
    ISMN = 9,
    OPUS_ID = 10,
    OPUS_PATH = '/frontdoor/index/index/docId/', // vor dem OPUS_PATH muss der hochschulspezifische Namensraum eingefügt werden
    PMID = 11,
    PMID_PATH = 'https://www.ncbi.nlm.nih.gov/pubmed/',
    PMID_PMC_PATH = 'https://europepmc.org/abstract/MED/',
    SCOPUS_ID = 12,
    UPC = 13,
    URN = 14,
    URN_PATH = 'https://nbn-resolving.org/',
    WOS_ID = 15,
    WOS_PATH = 'http://ws.isiknowledge.com/cps/openurl/service?url_ver=Z39.88-2004&rft_id=info:ut/'
}

export class GlobalIdentifierType {

    public static analogIdentifiers() {
        return [
            GlobalIdentifierEnum.ISBN, GlobalIdentifierEnum.ISSN,
            GlobalIdentifierEnum.EISSN, GlobalIdentifierEnum.ISMN, GlobalIdentifierEnum.UPC
        ];
    }

}
